<template>
  <div id="shopping-banner">
    <div class="wrap">
      <div class="wrap_zh shopping-banners">
        <div class="block">
          <el-carousel height="460px">
            <el-carousel-item>
              <img src="../../assets/images/shopping/home_banner.png" alt>
            </el-carousel-item>
            <el-carousel-item>
              <img src="../../assets/images/shopping/product_banner.png" alt>
            </el-carousel-item>
          </el-carousel>
        </div>
      </div>
    </div>
  </div>
</template>
<script type="text/javascript">
export default {
  name: "shopping-banner",
  data() {
    return {};
  },
  created() {},
  methods: {}
};
</script>
<style type="text/css">
.shopping-banners {
  position: relative;
} /*banner*/
.banner {
  width: 100%;
  height: 460px;
  overflow: hidden;
}

.banner ul {
  float: left;
  width: 3600px;
}
.banner ul li {
  float: left;
  width: 1200px;
  height: 460px;
}
.banner ul li img {
  width: 1200px;
  height: 460px;
}
.banner-bottom {
  margin-top: -30px;
  width: 100%;
  text-align: center;
}
.banner-bottom li {
  display: inline-block;
  margin-right: 3px;
  margin-left: 3px;
  width: 12px;
  height: 12px;
  background: #ffffff;
  border: 2px solid #c6c6c6;
  border-radius: 50%;
  cursor: pointer;
}
.banner-bottom li.on {
  background: #333333;
  opacity: 0.5;
  border-radius: 50%;
  border: none;
}

.wrap-shop_left-btn {
  position: absolute;
  left: 0px;
  top: 190px;
  width: 40px;
  height: 80px;
  background: url("../../assets/images/shopping/home_icon_leftarrow.png")
    no-repeat center #999794;
  cursor: pointer;
}
.wrap-shop_right-btn {
  position: absolute;
  right: 0px;
  top: 190px;
  width: 40px;
  height: 80px;
  background: url("../../assets/images/shopping/home_icon_rightarrow.png")
    no-repeat center #999794;
  cursor: pointer;
}
</style>


// WEBPACK FOOTER //
// src/components/shoppingMall/shoppingBanner.vue